<template>
  <v-container>
    <h4 class="align-left pa-2 section-title">{{ currentRouteName.replace('-', ' ') }}</h4>
    <v-card id="container-holder">
      <v-row id="content-container">
        <v-container class="content-container-nav">
          <v-row>
            <v-col class="text-left">
              <span class="robotoBoldFont">Vue API</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-left section-part robotoRegularFont">
              Zum Datenaustausch zwischen Web-Frontend und dem Server steht die Vue API-Dokumentation zur Verfügung.
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-left section-part" @click="goToVueAPI">
              <span class="api_link primary--text robotoBoldFont">Zu VUE API</span><v-icon color="primary">mdi-arrow-right</v-icon>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-left">
              <span class="robotoBoldFont">Apps API</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-left section-part robotoRegularFont">
              Zum Datenaustausch mit den Apps steht die Apps API-Dokumentation zur Verfügung.
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-left section-part" @click="goToAppsApi">
              <span class="api_link primary--text robotoBoldFont">Zu Apps API</span><v-icon color="primary">mdi-arrow-right</v-icon>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="text-left robotoBoldFont">
              <span>Swagger UI</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-left section-part robotoRegularFont">
              Swagger-UI ist eine interaktive Dokumentation, mit der Serverantworten angesehen und erstellt werden können. Daten für den Login in den Swagger-UI Bereich sind identisch zu den initial verwendeten.
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-left section-part" @click="goToSwaggerUI">
              <span class="api_link primary--text robotoBoldFont">Zu Swagger UI</span><v-icon color="primary">mdi-arrow-right</v-icon>
            </v-col>
          </v-row>
        </v-container>
        <v-container class="content-container-nav">
          <v-row>
            <v-col class="text-left robotoBoldFont">
              <span>Produktkennung</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-left section-part robotoRegularFont">
              Wählen Sie ein Produkt aus, um die Produktkennung für die API-Nutzung herauszufinden:
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-left">
              <v-select
                  style="width: 80%"
                  :items="products"
                  v-model="selectedProduct"
                  label="Produkt"
                  item-text="name"
                  item-value="identifier"
                  persistent-hint
                  return-object
                  outlined>
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-left section-part">
              <v-icon color="primary" @click="copyToClipBoard">mdi-clipboard-text</v-icon>
              <span class="robotoMediumFont">{{ this.selectedProduct ? this.selectedProduct.identifier : '' }}</span>
            </v-col>
          </v-row>
        </v-container>
      </v-row>
    </v-card>
    <v-snackbar
        v-model="snackbar"
    >
      Die Produktkennung wurde kopiert

      <v-btn
          color="secondary"
          text
          @click="snackbar = false"
      >
        Schließen
      </v-btn>
    </v-snackbar>
  </v-container>

</template>
<!-- TODO change lang to ts instead js to enable typescript-->
<script lang="js">
import config from '@/config'
import productsApi from "@/api/products";
import RouteInfo from "@/utils/RouteInfo";
import SortUtil from '@/utils/sortUitl'

export default {
  extends: RouteInfo,
  name: "API",
  data: () => {
    return {
      products: [],
      selectedProduct: null,
      snackbar: false
    }
  },
  mounted() {
    this.getProducts()
  },
  methods: {
    getProducts() {
      productsApi.getProducts().then((r) => {
        this.products = SortUtil.sortedNames(r.data)
        this.selectedProduct = this.products[0]
      })
    },
    goToSwaggerUI() {
      const win = window.open(`${config.baseURL}/apidocs/`, '_blank');
      win.focus();
    },
    goToVueAPI() {
      const win = window.open(`${config.baseURL}/vue_doc`, '_blank');
      win.focus();
    },
    goToAppsApi() {
      const win = window.open(`${config.baseURL}/static/apps_doc/index.html`, '_blank');
      win.focus()
    },
    copyToClipBoard() {
      const dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = this.selectedProduct ? this.selectedProduct.identifier : '';
      dummy.select();
      dummy.setSelectionRange(0, 99999); /* For mobile devices */
      document.execCommand("copy");
      document.body.removeChild(dummy);
      this.snackbar = true
    }
  }
}
</script>

<style scoped>
#container-holder {
  position: relative;
}

.row {
  margin-left: 0;
  width: 100%;
  padding-right: 30px;
}

.section-part {
  padding-top: 0;
  width: 40%;
}

h4 {
  padding: 0;
  width: 40%;
}

#content-container {
  position: absolute;
  top:0;
  right:0;
  bottom: 0;
  left: 0;
}
.content-container-nav{
  width: 50%;
  padding-top:0;
  padding-left:0;
}
.api_link {
  text-decoration: underline;
  margin-right: 8px;
  cursor: pointer;
}

.v-icon {
  padding-bottom: 5px;
}

span, .v-col {
  font-size: 18px;
}
</style>